export enum DiscountType {
  Manual = 'manual',
  Coupon = 'coupon',
  Rule = 'rule',
  Club = 'club',
}
